import { ContainerProps } from "./ContainerProps";
import classes from "./Container.module.scss";
import { clsx } from "clsx";

export function Container({
  children,
  className,
  maxWidth = "md",
  ref,
}: ContainerProps) {
  const containerClasses = clsx(
    classes.container,
    {
      [classes.xs]: maxWidth === "xs",
      [classes.sm]: maxWidth === "sm",
      [classes.md]: maxWidth === "md",
      [classes.lg]: maxWidth === "lg",
    },
    className,
  );

  return (
    <div ref={ref} className={containerClasses}>
      {children}
    </div>
  );
}
